import { ILaya } from "../../ILaya";
import { NodeFlags } from "../Const";
import { Event } from "../events/Event";
import { SerializeUtil } from "../loaders/SerializeUtil";
import { Loader } from "../net/Loader";
import { GWidget } from "./GWidget";
import { ImageRenderer } from "./ImageRenderer";
export class GImage extends GWidget {
    constructor() {
        super();
        this._src = "";
        this._loadId = 0;
        this._color = "#ffffff";
        this._autoSize = true;
        this._renderer = new ImageRenderer(this);
        this._renderer._onReload = () => this.onTextureReload();
    }
    get src() {
        return this._src;
    }
    set src(value) {
        if (value == null)
            value = "";
        if (this._src == value)
            return;
        this._src = value;
        let loadID = ++this._loadId;
        if (value) {
            let tex = SerializeUtil.isDeserializing ? null : Loader.getRes(value);
            if (tex)
                this.onLoaded(tex, loadID);
            else
                ILaya.loader.load(value, Loader.IMAGE).then(res => this.onLoaded(res, loadID));
        }
        else
            this.onLoaded(null, loadID);
    }
    get texture() {
        return this._renderer._tex;
    }
    set texture(value) {
        this._src = "instance-0";
        this.onLoaded(value, ++this._loadId);
    }
    get mesh() {
        return this._renderer._meshFactory;
    }
    set mesh(value) {
        this._renderer.setMesh(value);
    }
    get icon() {
        return this.src;
    }
    set icon(value) {
        this.src = value;
    }
    get autoSize() {
        return this._autoSize;
    }
    set autoSize(value) {
        if (this._autoSize != value) {
            if (value && this._renderer._tex)
                this.size(this._renderer._tex.sourceWidth, this._renderer._tex.sourceHeight);
            this._autoSize = value;
        }
    }
    get color() {
        return this._color;
    }
    set color(value) {
        this._color = value;
        this._renderer.setColor(value);
    }
    onLoaded(tex, loadID) {
        if (this._loadId != loadID || this.destroyed)
            return;
        this._renderer.setTexture(tex);
        if (this._autoSize) {
            if (tex)
                this.size(tex.sourceWidth, tex.sourceHeight);
            else if (!this._getBit(NodeFlags.EDITING_NODE))
                this.size(0, 0);
            this._autoSize = true;
        }
        this.event(Event.LOADED);
    }
    onTextureReload() {
        if (this._autoSize) {
            let tex = this._renderer._tex;
            this.size(tex.sourceWidth, tex.sourceHeight);
            this._autoSize = true;
        }
        this.event(Event.LOADED);
    }
    _sizeChanged(changeByLayout) {
        super._sizeChanged();
        if (!changeByLayout && !SerializeUtil.isDeserializing)
            this._autoSize = false;
    }
    destroy() {
        super.destroy();
        this._renderer.destroy();
    }
}
